module.exports = __webpack_public_path__ + "static/img/color.123f8cb1.jpg";